export default "__VITE_ASSET__D0CCwPhC__"